// // import { useState } from "react";
// // import CustomDropdown from "@/components/CustomDropdown";

// // const dropdownData = [
// //   {
// //     label: "Title",
// //     valueKey: "title",
// //     options: [
// //       { value: "", label: "Select your report title from here..." },
// //       { value: "title-1", label: "Title 1" },
// //       { value: "title-2", label: "Title 2" },
// //       { value: "title-3", label: "Title 3" },
// //     ],
// //   },
// //   {
// //     label: "Function",
// //     valueKey: "function",
// //     options: [
// //       { value: "", label: "Select your function from here..." },
// //       { value: "function-1", label: "Function 1" },
// //       { value: "function-2", label: "Function 2" },
// //       { value: "function-3", label: "Function 3" },
// //     ],
// //   },
// //   {
// //     label: "Sub-Function",
// //     valueKey: "subFunction",
// //     options: [
// //       { value: "", label: "Select your sub-function from here..." },
// //       { value: "sub-function-1", label: "Sub-function 1" },
// //       { value: "sub-function-2", label: "Sub-function 2" },
// //       { value: "sub-function-3", label: "Sub-function 3" },
// //     ],
// //   },
// // ];

// // const chartData = [
// //   {
// //     title: "Base Pay",
// //     average: "15.7 LPA",
// //     percentiles: {
// //       p25: "9.2 LPA",
// //       median: "15.3 LPA",
// //       p75: "20 LPA",
// //     },
// //   },
// //   {
// //     title: "Total Guaranteed Cash",
// //     average: "18.2 LPA",
// //     percentiles: {
// //       p25: "11.5 LPA",
// //       median: "17.8 LPA",
// //       p75: "24.2 LPA",
// //     },
// //   },
// // ];

// // const SalaryChart = ({ title, average }) => (
// //   <div className="mb-16">
// //     <h3 className="text-xl font-semibold text-themeBlue text-center mb-8">
// //       {title}
// //     </h3>
// //     <div className="text-center mb-6">
// //       <div className="text-sm text-themeInputTitleColor mb-1">
// //         Average Salary
// //       </div>
// //       <div className="text-lg font-medium text-themTextBlack">{average}</div>
// //     </div>

// //     <div className="relative max-w-2xl mx-auto">
// //       <div className="w-full flex items-center">
// //         {[
// //           "h-1 bg-blue-200",
// //           "h-2 bg-blue-300",
// //           "h-3 bg-blue-600",
// //           "h-2 bg-blue-500",
// //           "h-1 bg-blue-300",
// //         ].flatMap((cls, idx) => [
// //           <div key={`sep-${idx}`} className="w-px h-5 bg-blue-300"></div>,
// //           <div key={`bar-${idx}`} className={`flex-1 rounded-sm ${cls}`}></div>,
// //         ])}
// //         <div className="w-px h-4 bg-blue-300"></div>
// //       </div>

// //       <div
// //         className="absolute top-1/2 w-5 h-5 bg-themeOrange rounded-full z-50"
// //         style={{ left: "58%", transform: "translate(-50%, -50%)" }}
// //       />
// //     </div>
// //   </div>
// // );

// // const BenchmarkingByTitle = () => {
// //   const [formValues, setFormValues] = useState({
// //     title: "",
// //     function: "",
// //     subFunction: "",
// //   });

// //   const handleSelectChange = key => e => {
// //     setFormValues(prev => ({ ...prev, [key]: e.target.value }));
// //   };

// //   return (
// //     <>
// //       <div className="bg-themeCore">
// //         <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
// //           <h1 className="title text-themeBlue font-medium text-3xl">
// //             {"Benchmark Report By Title"}
// //           </h1>
// //         </div>
// //       </div>

// //       <main className="min-h-screen bg-white p-8 mt-5 rounded-lg">
// //         <div className="max-w-6xl mx-auto">
// //           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
// //             {dropdownData.map(({ label, valueKey, options }) => (
// //               <CustomDropdown
// //                 key={valueKey}
// //                 label={label}
// //                 value={formValues[valueKey]}
// //                 onChange={handleSelectChange(valueKey)}
// //                 options={options}
// //               />
// //             ))}
// //           </div>

// //           <section className="rounded-lg shadow-sm p-8">
// //             <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
// //               Data Visualization
// //             </h2>
// //             {chartData.map(chart => (
// //               <SalaryChart key={chart.title} {...chart} />
// //             ))}
// //           </section>
// //         </div>
// //       </main>
// //     </>
// //   );
// // };

// // export default BenchmarkingByTitle;

// // import { useState, useEffect } from "react";
// // import CustomDropdown from "@/components/CustomDropdown";
// // import {
// //   useFetchAllBusinessUnitsQuery,
// //   useFetchAllCompanyJobGradesQuery,
// //   useFetchAllJobFunctionsQuery,
// //   useFetchJobFunctionByIdQuery,
// // } from "@/services";

// // const BenchmarkingByTitle = ({ companyId = 6 }) => {
// //   const [formValues, setFormValues] = useState({
// //     title: "",
// //     region: "",
// //     country: "",
// //     grade: "",
// //     jobFunction: "",
// //     subJobFunction: "",
// //   });

// //   const [selectedRegion, setSelectedRegion] = useState(null);

// //   const { data: businessUnits } = useFetchAllBusinessUnitsQuery({ company_id: companyId });
// //   const { data: jobGradesData } = useFetchAllCompanyJobGradesQuery({ company_id: companyId });
// //   const { data: jobFunctionsData } = useFetchAllJobFunctionsQuery({ company_id: companyId });
// //   const { data: subJobFunctionData } = useFetchJobFunctionByIdQuery(
// //     formValues.jobFunction ? { job_id: formValues.jobFunction } : null,
// //     { skip: !formValues.jobFunction }
// //   );

// //   const countryOptions = (() => {
// //     const region = businessUnits?.data
// //       ?.flatMap(bu => bu.regions)
// //       .find(r => r.id === formValues.region);
// //     return region?.countries.map(c => ({ label: c.name, value: c.id })) || [];
// //   })();

// //   const handleSelectChange = key => value => {
// //     if (key === "region") setSelectedRegion(value);
// //     if (key === "jobFunction") setFormValues(prev => ({ ...prev, subJobFunction: "" }));
// //     setFormValues(prev => ({ ...prev, [key]: value }));
// //   };

// //   const handleSubmit = () => {
// //     const request = {
// //       country_id: Number(formValues.country),
// //       title: formValues.title,
// //       grade_id: Number(formValues.grade),
// //       job_function_id: Number(formValues.jobFunction),
// //       job_sub_function_id: Number(formValues.subJobFunction),
// //     };
// //     console.log("Request Payload:", request);
// //   };

// //   const dynamicFields = [
// //     {
// //       label: "Title",
// //       name: "title",
// //       type: "text",
// //       placeholder: "Enter report title...",
// //     },
// //     {
// //       label: "Business Unit",
// //       name: "region",
// //       options:
// //         businessUnits?.data
// //           ?.flatMap(bu => bu.regions.map(region => ({ label: region.name, value: region.id }))) || [],
// //     },
// //     {
// //       label: "Country",
// //       name: "country",
// //       options: countryOptions,
// //     },
// //     {
// //       label: "Grade",
// //       name: "grade",
// //       options: jobGradesData?.data?.map(g => ({ label: g.grade, value: g.id })) || [],
// //     },
// //     {
// //       label: "Job Function",
// //       name: "jobFunction",
// //       options: jobFunctionsData?.data?.map(f => ({ label: f.name, value: f.id })) || [],
// //     },
// //     {
// //       label: "Sub Job Function",
// //       name: "subJobFunction",
// //       options:
// //         subJobFunctionData?.data?.job_sub_functions?.map(s => ({ label: s.name, value: s.id })) || [],
// //     },
// //   ];

// //   const chartData = [
// //     {
// //       title: "Base Pay",
// //       average: "15.7 LPA",
// //       percentiles: {
// //         p25: "9.2 LPA",
// //         median: "15.3 LPA",
// //         p75: "20 LPA",
// //       },
// //     },
// //     {
// //       title: "Total Guaranteed Cash",
// //       average: "18.2 LPA",
// //       percentiles: {
// //         p25: "11.5 LPA",
// //         median: "17.8 LPA",
// //         p75: "24.2 LPA",
// //       },
// //     },
// //   ];

// //   const SalaryChart = ({ title, average }) => (
// //     <div className="mb-16">
// //       <h3 className="text-xl font-semibold text-themeBlue text-center mb-8">
// //         {title}
// //       </h3>
// //       <div className="text-center mb-6">
// //         <div className="text-sm text-themeInputTitleColor mb-1">
// //           Average Salary
// //         </div>
// //         <div className="text-lg font-medium text-themTextBlack">{average}</div>
// //       </div>

// //       <div className="relative max-w-2xl mx-auto">
// //         <div className="w-full flex items-center">
// //           {["h-1 bg-blue-200", "h-2 bg-blue-300", "h-3 bg-blue-600", "h-2 bg-blue-500", "h-1 bg-blue-300"].flatMap(
// //             (cls, idx) => [
// //               <div key={`sep-${idx}`} className="w-px h-5 bg-blue-300"></div>,
// //               <div key={`bar-${idx}`} className={`flex-1 rounded-sm ${cls}`}></div>,
// //             ]
// //           )}
// //           <div className="w-px h-4 bg-blue-300"></div>
// //         </div>

// //         <div
// //           className="absolute top-1/2 w-5 h-5 bg-themeOrange rounded-full z-50"
// //           style={{ left: "58%", transform: "translate(-50%, -50%)" }}
// //         />
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <>
// //       <div className="bg-themeCore">
// //         <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
// //           <h1 className="title text-themeBlue font-medium text-3xl">
// //             {"Benchmark Report By Title"}
// //           </h1>
// //         </div>
// //       </div>

// //       <main className="min-h-screen bg-white p-8 mt-5 rounded-lg">
// //         <div className="max-w-6xl mx-auto">
// //           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
// //             {dynamicFields.map(field =>
// //               field.type === "text" ? (
// //                 <div key={field.name}>
// //                   <label className="block mb-2 font-semibold text-lg text-themeBlue">{field.label}</label>
// //                   <input
// //                     type="text"
// //                     placeholder={field.placeholder}
// //                     value={formValues[field.name] || ""}
// //                     onChange={e => handleSelectChange(field.name)(e.target.value)}
// //                     className="w-full border px-4 py-2 rounded"
// //                   />
// //                 </div>
// //               ) : (
// //                 <CustomDropdown
// //                   key={field.name}
// //                   label={field.label}
// //                   value={formValues[field.name]}
// //                   onChange={handleSelectChange(field.name)}
// //                   options={field.options}
// //                 />
// //               )
// //             )}
// //           </div>

// //           <div className="text-center mb-12">
// //             <button
// //               onClick={handleSubmit}
// //               className="px-8 py-3 bg-themeBlue text-white font-semibold rounded"
// //             >
// //               Console Log Request
// //             </button>
// //           </div>

// //           <section className="rounded-lg shadow-sm p-8">
// //             <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
// //               Data Visualization
// //             </h2>
// //             {chartData.map(chart => (
// //               <SalaryChart key={chart.title} {...chart} />
// //             ))}
// //           </section>
// //         </div>
// //       </main>
// //     </>
// //   );
// // };

// // export default BenchmarkingByTitle;


// import { useState, useEffect } from "react";
// import CustomDropdown from "@/components/CustomDropdown";
// import {
//   useFetchAllBusinessUnitsQuery,
//   useFetchAllCompanyJobGradesQuery,
//   useFetchAllJobFunctionsQuery,
//   useFetchJobFunctionByIdQuery,
//   useBenchmarkingReportByTitleQuery,
// } from "@/services";


// function formatString(inputString) {

//   const formattedString = {
//     base_pay:"Base Pay",
//     direct_cash:"Total Direct Compensation",
//     guaranteed_cash:"Total Guaranteed Cash",
//     target_cash:"Target Total Cash",
//     total_remuneration:"Total Remuneration"
//   }

//   // if (typeof inputString !== 'string') {
//   //   throw new TypeError('Expected a string as input.');
//   // }
//   // // Replace all underscores with spaces.
//   // const spacedString = inputString.replace(/_/g, ' ');

//   // // Split the string into an array of words, capitalize each word, and join them back.
//   // const formattedString = spacedString.split(' ').map(word => {
//   //   if (word.length === 0) {
//   //     return '';
//   //   }
//   //   return word.charAt(0).toUpperCase() + word.slice(1);
//   // }).join(' ');

//   return formattedString[inputString];
// }

// const BenchmarkingByTitle = ({ companyId = 6 }) => {
//   const [formValues, setFormValues] = useState({
//     title: "",
//     region: "",
//     country: "",
//     grade: "",
//     jobFunction: "",
//     subJobFunction: "",
//   });

//   const [selectedRegion, setSelectedRegion] = useState(null);
//   const [submitData, setSubmitData] = useState(null);

//   // const benchmarkingByTitleData = {
//   //   "offer_data": {
//   //     "base_pay": {
//   //       "average": 4973844.58,
//   //       "percentiles": {
//   //         "p25": 2512467,
//   //         "p50": 3410304,
//   //         "p75": 5948814.75
//   //       },
//   //       "count": 1436
//   //     },
//   //     "guaranteed_cash": {
//   //       "average": 4021101.19,
//   //       "percentiles": {
//   //         "p25": 0,
//   //         "p50": 3222108,
//   //         "p75": 4766334
//   //       },
//   //       "count": 1436
//   //     },
//   //     "target_cash": {
//   //       "average": 1979173.95,
//   //       "percentiles": {
//   //         "p25": 0,
//   //         "p50": 1353600,
//   //         "p75": 2667232.8
//   //       },
//   //       "count": 1436
//   //     },
//   //     "direct_cash": {
//   //       "average": 7153104.27,
//   //       "percentiles": {
//   //         "p25": 3070720.19,
//   //         "p50": 4999276.8,
//   //         "p75": 9044102.4
//   //       },
//   //       "count": 1436
//   //     },
//   //     "total_remuneration": {
//   //       "average": 8480286.48,
//   //       "percentiles": {
//   //         "p25": 3603399,
//   //         "p50": 5789819.37,
//   //         "p75": 10910524.21
//   //       },
//   //       "count": 1436
//   //     }
//   //   }
//   // }

//   // API Queries
//   const { data: businessUnits } = useFetchAllBusinessUnitsQuery({ company_id: companyId });
//   const { data: jobGradesData } = useFetchAllCompanyJobGradesQuery({ company_id: companyId });
//   const { data: jobFunctionsData } = useFetchAllJobFunctionsQuery({ company_id: companyId });
//   const { data: subJobFunctionData } = useFetchJobFunctionByIdQuery(
//     formValues.jobFunction ? { job_id: formValues.jobFunction } : null,
//     { skip: !formValues.jobFunction }
//   );

//   const isValidSubmitData = submitData !== null;

//   const { data: apiResponse, isLoading, isFetching, error } = useBenchmarkingReportByTitleQuery(
//     isValidSubmitData
//       ? { company_id: companyId, ...submitData }
//       : null,
//     { skip: !isValidSubmitData }
//   );


//   // Trigger API automatically when all fields are filled
//   useEffect(() => {
//     const isValid =
//       formValues.title &&
//       formValues.country &&
//       formValues.grade &&
//       formValues.jobFunction &&
//       formValues.subJobFunction;

//     if (isValid) {
//       const request = {
//         title: formValues.title,
//         country_id: Number(formValues.country),
//         grade_id: Number(formValues.grade),
//         job_function_id: Number(formValues.jobFunction),
//         job_sub_function_id: Number(formValues.subJobFunction),
//       };
  
//       setSubmitData(request);
//     } else {
//       setSubmitData(null);
//     }
//   }, [
//     formValues.title,
//     formValues.country,
//     formValues.grade,
//     formValues.jobFunction,
//     formValues.subJobFunction,
//   ]);

//   // Debug log
//   useEffect(() => {
//     if (apiResponse) {
//       console.log("API Response:", apiResponse);
//     }
//   }, [apiResponse]);

//   // Dynamic country options based on region
//   const countryOptions = (() => {
//     const region = businessUnits?.data
//       ?.flatMap(bu => bu.regions)
//       .find(r => r.id === formValues.region);
//     return region?.countries.map(c => ({ label: c.name, value: c.id })) || [];
//   })();

//   // Handle dropdown and input changes
//   const handleSelectChange = key => value => {
//     setFormValues(prev => {
//       const updated = { ...prev, [key]: value };

//       if (key === "region") {
//         setSelectedRegion(value);
//         updated.country = "";
//       }

//       if (key === "jobFunction") {
//         updated.subJobFunction = "";
//       }

//       return updated;
//     });
//   };

//   const dynamicFields = [
//     {
//       label: "Title",
//       name: "title",
//       type: "text",
//       placeholder: "Enter report title...",
//     },
//     {
//       label: "Regions",
//       name: "region",
//       options:
//         businessUnits?.data
//           ?.flatMap(bu => bu.regions.map(region => ({ label: region.name, value: region.id }))) || [],
//     },
//     {
//       label: "Country",
//       name: "country",
//       options: countryOptions,
//     },
//     {
//       label: "Grade",
//       name: "grade",
//       options: jobGradesData?.data?.map(g => ({ label: g.grade, value: g.id })) || [],
//     },
//     {
//       label: "Job Function",
//       name: "jobFunction",
//       options: jobFunctionsData?.data?.map(f => ({ label: f.name, value: f.id })) || [],
//     },
//     {
//       label: "Sub Job Function",
//       name: "subJobFunction",
//       options:
//         subJobFunctionData?.data?.job_sub_functions?.map(s => ({ label: s.name, value: s.id })) || [],
//     },
//   ];

//   const SalaryChart = ({ title, average, percentiles }) => {

//     return <div className="mb-16">
//       <h3 className="text-xl font-semibold text-themeBlue text-center mb-8">
//         {formatString(title)}
//       </h3>
//       <div className="text-center mb-6">
//         <div className="text-sm text-themeInputTitleColor mb-1">
//           Average Salary
//         </div>
//         <div className="text-lg font-medium text-themTextBlack">{parseInt(average)} LPA</div>
//       </div>

//       <div className="relative max-w-2xl mx-auto">
//         <div className="w-full flex items-center">
//           {["h-1 bg-blue-200", "h-2 bg-blue-300", "h-3 bg-blue-600", "h-2 bg-blue-500", "h-1 bg-blue-300"].flatMap(
//             (cls, idx) => [
//               <div key={`sep-${idx}`} className="w-px h-5 bg-blue-300"></div>,
//               <div key={`bar-${idx}`} className={`flex-1 rounded-sm ${cls}`}></div>,
//             ]
//           )}
//           <div className="w-px h-4 bg-blue-300"></div>
//         </div>

//         <div
//           className="absolute top-1/2 w-5 h-5 bg-themeOrange rounded-full z-50"
//           style={{ left: "50%", transform: "translate(-50%, -50%)" }}
//         />
//       </div>
//       <div className="percentilesMap flex justify-between gap-1 items-center py-2 max-w-2xl mx-auto">
//         {
//           Object.entries(percentiles).map((item, key) => {
//             return (
//               <div
//                 key={item[0]}
//                 className={``}
//               >
//                 <div className={` mx-auto`} style={{
//                   width: "fit-content",

//                 }}>
//                   <div className="title font-semibold text-xs text-center">
//                     {item[0] === 'p25'
//                       ? '25th Percentile'
//                       : item[0] === 'p50'
//                         ? 'Median'
//                         : '75th Percentile'}
//                   </div>
//                   <div className="value text-xs text-center">{parseInt(item[1])} LPA</div>
//                 </div>
//               </div>
//             );
//           })
//         }

//       </div>
//     </div>
//   };

//   return (
//     <>
//       <div className="bg-themeCore">
//         <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
//           <h1 className="title text-themeBlue font-medium text-3xl">
//             Benchmark Report By Title
//           </h1>
//         </div>
//       </div>

//       <main className="min-h-screen bg-white p-8 mt-5 rounded-lg">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
//             {dynamicFields.map(field =>
//               field.type === "text" ? (
//                 <div key={field.name}>
//                   <label className="block mb-2 font-semibold text-lg text-themeBlue">
//                     {field.label}
//                   </label>
//                   <input
//                     type="text"
//                     placeholder={field.placeholder}
//                     value={formValues[field.name] || ""}
//                     onChange={e => handleSelectChange(field.name)(e.target.value)}
//                     className="w-full border text-lg px-4 py-2 mt-1 rounded-md"
//                   />
//                 </div>
//               ) : (
//                 <CustomDropdown
//                   key={field.name}
//                   label={field.label}
//                   value={formValues[field.name]}
//                   onChange={handleSelectChange(field.name)}
//                   options={field.options}
//                   placeholder={field.name}
//                 />
//               )
//             )}
//           </div>

//           {/* <section className="rounded-lg shadow-sm p-8">
//             <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
//               Data Visualization
//             </h2>


//             {
//              apiResponse && Object.entries(apiResponse?.offer_data).map((item) => {
//                 return <SalaryChart key={JSON.stringify(item[0])} title={item[0] || ""} {...item[1]} />

//               })
//             }
//           </section> */}

//           <section className="rounded-lg shadow-sm p-8">
//             <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
//               Data Visualization
//             </h2>

//             {/* Initial state */}
//             {!isValidSubmitData && (
//               <p className="text-center text-gray-400">
//                 Please fill out all the fields above to see the benchmarking report.
//               </p>
//             )}

//             {/* Loading */}
//             {isLoading && (
//               <p className="text-center text-gray-500">Loading report...</p>
//             )}

//             {/* Network/Server error */}
//             {error && (
//               <p className="text-center text-red-500">
//                 {error?.message || "Something went wrong while fetching the report."}
//               </p>
//             )}


//             {/* Success with data */}
//            {/* ✅ Success with data */}
//   {apiResponse && !isLoading && !error && (() => {
//     const offerData = apiResponse?.offer_data || apiResponse?.data?.offer_data;

//     if (offerData && Object.keys(offerData).length > 0) {
//       return Object.entries(offerData).map(([key, value]) => (
//         <SalaryChart key={key} title={key} {...value} />
//       ));
//     }

//     return (
//       <p className="text-center text-gray-400">
//         No salary data available for the selected filters.
//       </p>
//     );
//   })()}

//           </section>



//         </div>
//       </main>
//     </>
//   );
// };

// export default BenchmarkingByTitle;

import { useState, useEffect } from "react";
import CustomDropdown from "@/components/CustomDropdown";
import {
  useFetchAllCompanyJobGradesQuery,
  useFetchRegionsForLivePayQuery,
  useFetchCompanyJobFunctionsQuery,
  useBenchmarkingReportByTitleQuery,
} from "@/services";
import { useTypedSelector } from "@/hooks";

function formatString(inputString) {
  const formattedString = {
    base_pay: "Base Pay",
    direct_cash: "Total Direct Compensation",
    guaranteed_cash: "Total Guaranteed Cash",
    target_cash: "Target Total Cash",
    total_remuneration: "Total Remuneration",
    total_direct_compensation: "Total Direct Compensation",
  };
  return formattedString[inputString] || inputString;
}

const formatNumberWithCommas = (number: any): string | null => {
      // Check if the number is null, undefined, or NaN, or if it's an empty string
      if (number == null || isNaN(Number(number)) || number === "") return null;
  
      // Convert input to a number if it's a string
      const numericValue = Number(number);
  
      // If the number is zero, return "0" explicitly
      if (numericValue === 0) return "";
  
      // Return the formatted number with commas using toLocaleString
      return numericValue.toLocaleString();
    };

const BenchmarkingByTitle = () => {
  const companyId = useTypedSelector((state) => state.auth?.user?.company?.id);

  const initialFormValues = {
    title: "",
    region: "",
    country: "",
    grade: "",
    jobFunction: "",
    subJobFunction: "",
    reportOn: "",
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [submitData, setSubmitData] = useState(null);

  // API Queries
  const { data: livePayRegions } = useFetchRegionsForLivePayQuery({
    company_id: companyId,
  });
  const { data: jobGradesData } = useFetchAllCompanyJobGradesQuery({
    company_id: companyId,
    paginate:false
  });
  const { data: companyJobFunctionsData } = useFetchCompanyJobFunctionsQuery({
    companyId,
    reportOn: formValues.reportOn,
  });

  const isValidSubmitData = submitData !== null;

  const { data: apiResponse, isLoading, error } =
    useBenchmarkingReportByTitleQuery(
      isValidSubmitData ? { company_id: companyId, ...submitData } : null,
      { skip: !isValidSubmitData }
    );

  // ✅ Reset all fields when companyId changes
  useEffect(() => {
    setFormValues(initialFormValues);
    setSubmitData(null);
  }, [companyId]);

  // ✅ Auto-trigger API when all fields are filled
  useEffect(() => {
    const isValid =
      formValues.title &&
      formValues.country &&
      formValues.grade &&
      formValues.jobFunction &&
      formValues.subJobFunction &&
      formValues.reportOn;

    if (isValid) {
      const request = {
        title: formValues.title,
        country_id: Number(formValues.country),
        grade_id: Number(formValues.grade),
        job_function_id: Number(formValues.jobFunction),
        job_sub_function_id: Number(formValues.subJobFunction),
        report_on: formValues.reportOn,
      };
      setSubmitData(request);
    } else {
      setSubmitData(null);
    }
  }, [formValues]);

  // Debug log
  useEffect(() => {
    if (apiResponse) {
    }
  }, [apiResponse]);

  // Options Mapping
  const regionOptions =
    livePayRegions?.data?.map((r) => ({ label: r.name, value: r.id })) || [];

  const countryOptions = (() => {
    const region = livePayRegions?.data?.find(
      (r) => r.id === formValues.region
    );
    return region?.countries.map((c) => ({ label: c.name, value: c.id })) || [];
  })();

  const jobFunctionOptions =
    companyJobFunctionsData?.data?.map((f) => ({
      label: f.name,
      value: f.id,
    })) || [];

  const subJobFunctionOptions =
    companyJobFunctionsData?.data
      ?.find((f) => f.id === Number(formValues.jobFunction))
      ?.job_sub_functions?.map((s) => ({ label: s.name, value: s.id })) || [];

  // ✅ Handle dropdown & input changes with dependency resets
  const handleSelectChange = (key) => (value) => {
    setFormValues((prev) => {
      const updated = { ...prev, [key]: value };

      if (key === "region") {
        updated.country = ""; // reset child
      }
      if (key === "jobFunction") {
        updated.subJobFunction = ""; // reset child
      }
      if (key === "reportOn") {
        updated.jobFunction = "";
        updated.subJobFunction = "";
        updated.grade = "";
      }

      return updated;
    });
  };

  // Dynamic fields config
  const dynamicFields = [
    {
      label: "Title",
      name: "title",
      type: "text",
      placeholder: "Enter report title...",
    },
    {
      label: "Region",
      name: "region",
      options: regionOptions,
    },
    {
      label: "Country",
      name: "country",
      options: countryOptions,
    },
    {
      label: "Report On",
      name: "reportOn",
      options: [
        { label: "Tom Data", value: "tom_data" },
        { label: "Payroll Data", value: "payroll_data" },
        { label: "Aggregate", value: "aggregate" },
      ],
    },
    {
      label: "Grade",
      name: "grade",
      options:
        jobGradesData?.data?.map((g) => ({
          label: g.grade,
          value: g.id,
        })) || [],
    },
    {
      label: "Job Function",
      name: "jobFunction",
      options: jobFunctionOptions,
    },
    {
      label: "Sub Job Function",
      name: "subJobFunction",
      options: subJobFunctionOptions,
    },
  ];

  // Salary Chart
  const SalaryChart = ({ title, average, percentiles }) => (
    <div className="mb-16">
      <h3 className="text-xl font-semibold text-themeBlue text-center mb-8">
        {formatString(title)}
      </h3>
      <div className="text-center mb-6">
        <div className="text-sm text-themeInputTitleColor mb-1">
          Average Salary
        </div>
        <div className="text-lg font-medium text-themTextBlack">
          {formatNumberWithCommas(parseInt(average))}
        </div>
      </div>

      <div className="relative max-w-2xl mx-auto">
        <div className="w-full flex items-center">
          {[
            "h-1 bg-blue-200",
            "h-2 bg-blue-300",
            "h-3 bg-blue-600",
            "h-2 bg-blue-500",
            "h-1 bg-blue-300",
          ].flatMap((cls, idx) => [
            <div key={`sep-${idx}`} className="w-px h-5 bg-blue-300"></div>,
            <div
              key={`bar-${idx}`}
              className={`flex-1 rounded-sm ${cls}`}
            ></div>,
          ])}
          <div className="w-px h-4 bg-blue-300"></div>
        </div>

<div
  className="absolute top-1/2 w-5 h-5 bg-themeOrange rounded-full z-40"
  style={{
    left: (() => {
      const p25 = percentiles?.p25;
      const p50 = percentiles?.p50;
      const p75 = percentiles?.p75;

      if (!p25 || !p50 || !p75) return "50%";

      // Normalize to median scale ONLY
      let percent;

      if (average <= p50) {
        // Average is below median → map to left half (0% → 50%)
        percent = ((average - p25) / (p50 - p25)) * 50;
      } else {
        // Average is above median → map to right half (50% → 100%)
        percent = 50 + ((average - p50) / (p75 - p50)) * 50;
      }

      // Clamp within entire 0–100% center section
      percent = Math.max(0, Math.min(percent, 100));

      return percent + "%";
    })(),
    transform: "translate(-50%, -50%)",
  }}
/>


      </div>

      <div className="percentilesMap flex justify-between gap-1 items-center py-2 max-w-2xl mx-auto">
        {Object.entries(percentiles).map(([key, val]) => (
          <div key={key}>
            <div className="title font-semibold text-xs text-center">
              {key === "p25"
                ? "25th Percentile"
                : key === "p50"
                ? "Median"
                : "75th Percentile"}
            </div>
            <div className="value text-xs text-center">
              {formatNumberWithCommas(parseInt(val))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
  // const SalaryChart = ({ title, average, percentiles }) => (
  //   <div className="mb-16">
  //     <h3 className="text-xl font-semibold text-themeBlue text-center mb-8">
  //       {formatString(title)}
  //     </h3>
  //     <div className="text-center mb-6">
  //       <div className="text-sm text-themeInputTitleColor mb-1">
  //         Average Salary
  //       </div>
  //       <div className="text-lg font-medium text-themTextBlack">
  //         {formatNumberWithCommas(parseInt(average))}
  //       </div>
  //     </div>

  //     <div className="relative max-w-2xl mx-auto">
  //       <div className="w-full flex items-center">
  //         {[
  //           "h-1 bg-blue-200",
  //           "h-2 bg-blue-300",
  //           "h-3 bg-blue-600",
  //           "h-2 bg-blue-500",
  //           "h-1 bg-blue-300",
  //         ].flatMap((cls, idx) => [
  //           <div key={`sep-${idx}`} className="w-px h-5 bg-blue-300"></div>,
  //           <div
  //             key={`bar-${idx}`}
  //             className={`flex-1 rounded-sm ${cls}`}
  //           ></div>,
  //         ])}
  //         <div className="w-px h-4 bg-blue-300"></div>
  //       </div>

  //       <div
  //         className="absolute top-1/2 w-5 h-5 bg-themeOrange rounded-full z-50"
  //         style={{ left: average>percentiles?.p75?"98.5%":average<0?"1.5%":(average/percentiles?.p75)*100+"%", transform: "translate(-50%, -50%)" }}
  //       />
  //     </div>

  //     <div className="percentilesMap flex justify-between gap-1 items-center py-2 max-w-2xl mx-auto">
  //       {Object.entries(percentiles).map(([key, val]) => (
  //         <div key={key}>
  //           <div className="title font-semibold text-xs text-center">
  //             {key === "p25"
  //               ? "25th Percentile"
  //               : key === "p50"
  //               ? "Median"
  //               : "75th Percentile"}
  //           </div>
  //           <div className="value text-xs text-center">
  //             {formatNumberWithCommas(parseInt(val))}
  //           </div>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );

// const SalaryChart = ({ title, average, percentiles }) => {
//   const p25 = percentiles?.p25;
//   const p50 = percentiles?.p50;
//   const p75 = percentiles?.p75;

//   // 🔥 Correct scale mapping:
//   // p25 → 20%  |  p50 → 50%  |  p75 → 80%
//   let pos = ((average - p25) / (p75 - p25)) * 60+35;

//   // Clamp between edges
//   pos = Math.max(1.5, Math.min(98.5, pos));

//   return (
//     <div className="mb-16">
//       <h3 className="text-xl font-semibold text-themeBlue text-center mb-8">
//         {formatString(title)}
//       </h3>

//       <div className="text-center mb-6">
//         <div className="text-sm text-themeInputTitleColor mb-1">
//           Average Salary
//         </div>
//         <div className="text-lg font-medium text-themTextBlack">
//           {formatNumberWithCommas(parseInt(average))}
//         </div>
//       </div>

//       <div className="relative max-w-2xl mx-auto">
//         {/* 🔵 BAR WITH 5 SEGMENTS (Median visually centered) */}
//         <div className="w-full flex items-center">
//           {[
//             "h-1 bg-blue-200",
//             "h-2 bg-blue-300",
//             "h-3 bg-blue-600", // ← Median region (center)
//             "h-2 bg-blue-500",
//             "h-1 bg-blue-300",
//           ].flatMap((cls, idx) => [
//             <div key={`sep-${idx}`} className="w-px h-5 bg-blue-300"></div>,
//             <div key={`bar-${idx}`} className={`flex-1 rounded-sm ${cls}`}></div>,
//           ])}
//           <div className="w-px h-4 bg-blue-300"></div>
//         </div>

//         {/* 🔴 CORRECTLY PLACED RED DOT */}
//         <div
//           className="absolute top-1/2 w-5 h-5 bg-themeOrange rounded-full z-50"
//           style={{
//             left: `${pos}%`,
//             transform: "translate(-50%, -50%)",
//           }}
//         />
//       </div>

//       {/* Bottom Percentiles */}
//       <div className="percentilesMap flex justify-between gap-1 items-center py-2 max-w-2xl mx-auto">
//         {Object.entries(percentiles).map(([key, val]) => (
//           <div key={key}>
//             <div className="title font-semibold text-xs text-center">
//               {key === "p25"
//                 ? "25th Percentile"
//                 : key === "p50"
//                 ? "Median"
//                 : "75th Percentile"}
//             </div>
//             <div className="value text-xs text-center">
//               {formatNumberWithCommas(parseInt(val))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };



  return (
    <>
      <div className="bg-themeCore">
        <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
          <h1 className="title text-themeBlue font-medium text-3xl">
            Benchmark Report By Title
          </h1>
        </div>
      </div>

      <main className="min-h-screen bg-white p-8 mt-5 rounded-lg">
        <div className="max-w-6xl mx-auto">
          {/* Dynamic fields */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {dynamicFields.map((field) =>
              field.type === "text" ? (
                <div key={field.name}>
                  <label className="block mb-2 font-semibold text-lg text-themeBlue">
                    {field.label}
                  </label>
                  <input
                    type="text"
                    placeholder={field.placeholder}
                    value={formValues[field.name] || ""}
                    onChange={(e) =>
                      handleSelectChange(field.name)(e.target.value)
                    }
                    className="w-full border text-lg px-4 py-2 mt-1 rounded-md"
                  />
                </div>
              ) : (
                <CustomDropdown
                  key={field.name}
                  label={field.label}
                  value={formValues[field.name]}
                  onChange={handleSelectChange(field.name)}
                  options={field.options}
                  placeholder={field.label}
                />
              )
            )}
          </div>

          {/* Data Visualization Section */}
          <section className="rounded-lg shadow-sm p-8">
            <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
              Data Visualization
            </h2>

                  {/* <SalaryChart title={"test"} average={1577212} percentiles={{p25:1265062,p50:1561495,p75:2024934}} /> */}

            {!isValidSubmitData && (
              <p className="text-center text-gray-400">
                Please fill out all the fields above to see the benchmarking
                report.
              </p>
            )}

            {isLoading && (
              <p className="text-center text-gray-500">Loading report...</p>
            )}

            {error && (
              <p className="text-center text-red-500">
                {error?.message ||
                  "Something went wrong while fetching the report."}
              </p>
            )}

            {isValidSubmitData && apiResponse && !isLoading && !error && (() => {
              const offerData =
                apiResponse?.offer_data || apiResponse?.data?.offer_data;

              if (offerData && Object.keys(offerData).length > 0) {
                return Object.entries(offerData).map(([key, value]) => (
                  <SalaryChart key={key} title={key} {...value} />
                ));
              }

              return (
                <p className="text-center text-gray-400">
                  No salary data available for the selected filters.
                </p>
              );
            })()}
          </section>
        </div>
      </main>
    </>
  );
};

export default BenchmarkingByTitle;
